import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
	Alert,
	AlertDescription,
	AlertIcon,
	AlertTitle,
	Badge,
	Box,
	Checkbox,
	Collapse,
	Flex,
	FormControl,
	HStack,
	Icon,
	IconButton,
	Input,
	InputGroup,
	InputRightElement,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Select,
	SimpleGrid,
	Spinner,
	Td,
	Text,
	Textarea,
	Tooltip,
	Tr,
	useColorModeValue,
	useDisclosure,
	useToast,
	VStack,
} from "@chakra-ui/react";
import moment from "moment/moment";
import { DownloadIcon, HamburgerIcon } from "@chakra-ui/icons";
import { FiCalendar, FiCheckCircle, FiCreditCard, FiFileText, FiGlobe, FiHash, FiInfo, FiUpload, FiUser } from "react-icons/fi";

import {
	MODAL_GRID_SPACING,
	MODAL_SECTION_SPACING,
	ModalFieldLabel,
	ModalFooterActions,
	PropertyConfirmModal,
	PropertyModalSection,
	PropertyModalShell,
} from "../PropertyModal/shared";

import { addPaymentDocumentAsync, markPaymentAsPaidAsync, markRentAsPaidAsync, removePaymentAsync, updateStatus } from "../../redux/user/userSlice";
import { _arrayBufferToBase64 } from "../../utils/convertors";
import { API } from "../../utils/http";
import { fullDateFormat, fullDateTimeFormat } from "../../utils/types";
import { getPaymentStatus, getPaymentStatusColor } from "../../utils/utils";
import { markAsPaidVerifier } from "../../utils/verifier";
import Dropzone from "../Dropzone/Dropzone";
function InvoicesRow(props) {
	const { date, code, dueDate, exchange, amount, type, paymentDate, method, documents, property, id, currency, paymentDirection, description } = props;
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const iconColor = useColorModeValue("blue.500", "blue.300");
	const loading = useSelector((state) => state.user.status) === "loading";
	const [exchangeRateLoading, setExchangeRateLoading] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { isOpen: isMarkAsPaidOpen, onOpen: onMarkAsPaidOpen, onClose: onMarkAsPaidClose } = useDisclosure();
	const { isOpen: isDeleteConfirmationOpen, onOpen: onDeleteConfirmationOpen, onClose: onDeleteConfirmationClose } = useDisclosure();
	const [error, setError] = useState({});
	const [addDocumentInformation, setAddDocumentInformation] = useState({ documentName: "", documentData: "", contentType: "" });
	const toast = useToast();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const paymentStatus = getPaymentStatus({ paymentDate, dueDate });
	const initialMarkAsPaidInformation = {
		billedTo: {},
		documentNumber: "",
		documents: [],
		amount: amount,
		// amount: "",
		// currency: "ron",
		paymentDate: moment().format("yyyy-MM-DD"),
		paymentMethod: "cash",
		propertyId: property.id,
		description: "",
	};
	const [markAsPaidInformation, setMarkAsPaidInformation] = useState(initialMarkAsPaidInformation);
	const handleChangeMarkAsPaidInformation = (e) => {
		setMarkAsPaidInformation({ ...markAsPaidInformation, [e.target.name]: e.target.value });
	};
	useEffect(() => {
		console.log(markAsPaidInformation);
	}, [markAsPaidInformation]);
	const onDocumentDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		let documents = [];
		for (const file of acceptedFiles) {
			const buffer = await file.arrayBuffer();
			const documentName = file.name;
			const contentType = file.type;
			documents.push({ documentData: _arrayBufferToBase64(buffer), documentName, contentType });
		}

		setMarkAsPaidInformation({ ...markAsPaidInformation, documents });
	};
	const onAddDocumentDrop = async (acceptedFiles) => {
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const documentName = acceptedFiles[0].name;
		const contentType = acceptedFiles[0].type;

		// setMarkAsPaidInformation({ ...markAsPaidInformation, documents });
		setAddDocumentInformation({ documentData: _arrayBufferToBase64(buffer), documentName, contentType });
	};
	const generateDisposition = () => {
		//call api to generate disposition based on the payment id
		const payload = { paymentId: id, propertyId: property.id };
		console.log(payload);
		dispatch(updateStatus("loading"));
		API.post("/generate-disposition", payload)
			.then((res) => {
				console.log(res);
				const pdfBuffer = res.data.disposition.data;
				const data = Uint8Array.from(pdfBuffer);
				var blob = new Blob([data.buffer], { type: "application/pdf" });
				var link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				var fileName = "dispozitie.pdf";
				link.download = fileName;
				link.click();
			})
			.finally(() => {
				dispatch(updateStatus("idle"));
			});
	};
	const handleBilledToChange = (e) => {
		const billedToEmail = e.target.value;
		console.log("email: ", billedToEmail);
		if (property.owner.email === billedToEmail) {
			setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { name: property.owner.name, email: billedToEmail, type: "owner" } });
			return;
		}
		if (property.contacts.find((c) => c.email === billedToEmail)) {
			const contact = property.contacts.find((c) => c.email === billedToEmail);
			console.log(contact);
			setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { name: contact.name, email: billedToEmail, type: contact.contactType } });
			return;
		}
		if (property.leaseContacts.find((c) => c.id === billedToEmail)) {
			const contact = property.leaseContacts.find((c) => c.id === billedToEmail);
			console.log(contact);
			setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { name: contact.name, email: billedToEmail, type: contact.contactType } });
			return;
		}
		if (property.tenants.find((c) => c.email === billedToEmail)) {
			const tenant = property.tenants.find((c) => c.email === billedToEmail);
			console.log(tenant);
			setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { name: tenant.name, email: billedToEmail, type: "tenant" } });
			return;
		}
	};
	const handleSaveMarkAsPaid = () => {
		const admCtr = property.documents.find((d) => d.type === "administrationContract" && d.active);
		const leaseCtr = property.documents.find((d) => d.type === "lease" && d.active);
		console.log(markAsPaidInformation);
		console.log("payment id: ", id);
		const payload = {
			...markAsPaidInformation,
			paymentId: id,
			administrationContractDate: admCtr?.startingDate || "Not available",
			administrationContractNumber: admCtr?.number || "Not available",
			leaseNumber: leaseCtr?.number || "Not available",
			leaseDate: leaseCtr?.signatureDate || "Not available",
		};
		console.log(payload);
		const errors = markAsPaidVerifier(payload);
		console.log(errors);
		setError(errors);
		if (Object.keys(errors).length > 0) {
			toast({
				title: "Error encountered",
				description: "Please fill in all the required fields",
				status: "error",
				duration: 9000,
				isClosable: true,
			});
			return;
		}

		if (type === "rent") {
			console.log("mark rent as paid");
			dispatch(markRentAsPaidAsync(payload)).finally(() => {
				onMarkAsPaidClose();
				setMarkAsPaidInformation(initialMarkAsPaidInformation);
			});
		} else {
			dispatch(markPaymentAsPaidAsync(payload)).finally(() => {
				onMarkAsPaidClose();
				setMarkAsPaidInformation(initialMarkAsPaidInformation);
			});
		}
	};
	const handleAddDocument = () => {
		console.log(addDocumentInformation);
		const payload = { ...addDocumentInformation, paymentId: id, propertyId: property.id };
		console.log(payload);
		dispatch(addPaymentDocumentAsync(payload)).finally(() => {
			onClose();
			setAddDocumentInformation({ documentData: "", documentName: "", contentType: "" });
		});
	};
	const handleGetDocument = (documentId, documentName) => {
		const payload = { propertyId: property.id, documentId, paymentId: id, documentName };
		console.log(payload);
		API.put("get-payment-document", payload)
			.then((r) => {
				console.log(r);
				window.open(r.data.url, "_blank");
			})
			.catch((e) => {
				console.log(e);
				toast({
					title: "Error encountered",
					description: e.response.data.error.message,
					status: "error",
					duration: 9000,
					isClosable: true,
				});
			});
	};
	const handleDeletePayment = () => {
		const payload = { propertyId: property.id, paymentId: id };
		console.log(payload);
		//dispatch remove payment
		dispatch(removePaymentAsync(payload))
			.then((r) => {
				if (r.error) {
					toast({
						title: "Error encountered",
						description: r.error.message,
						status: "error",
						duration: 9000,
						isClosable: true,
					});
				} else {
					toast({
						title: "Success",
						description: "Payment deleted successfully",
						status: "success",
						duration: 9000,
						isClosable: true,
					});
				}
			})
			.catch((e) => {
				console.log(e);
			})
			.finally(() => {
				onDeleteConfirmationClose();
			});
	};
	const { isOpen: isDifferentCurrencyOpen, onToggle: onDifferentCurrencyToggle, onClose: onDifferentCurrencyClose } = useDisclosure();

	const renderMarkAsPaidModal = () => (
		<PropertyModalShell
			isOpen={isMarkAsPaidOpen}
			onClose={onMarkAsPaidClose}
			size="4xl"
			icon={FiCheckCircle}
			title={t("table.markAsPaid")}
			subtitle={t("property.completePaymentInfo")}
			footer={
				<ModalFooterActions
					isLoading={loading}
					onCancel={() => {
						onMarkAsPaidClose();
						onDifferentCurrencyClose();
					}}
					onConfirm={handleSaveMarkAsPaid}
					confirmLabel={t("misc.save")}
				/>
			}
		>
			<SimpleGrid columns={{ base: 1, lg: 2 }} spacing={MODAL_GRID_SPACING}>
				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection
						icon={FiInfo}
						title={t("property.paymentSummary")}
						headerExtra={
							<Badge colorScheme="blue" fontSize="xs" px={2} py={0.5} borderRadius="full">
								{t(`types.${type}`)}
							</Badge>
						}
					>
						<SimpleGrid columns={2} spacing={4}>
							{type.toLowerCase().includes("utility") ? (
								<FormControl>
									<ModalFieldLabel icon={FiHash}>{t("property.amount")}</ModalFieldLabel>
									<InputGroup size="sm">
										<Input
											isInvalid={error?.amount}
											type="number"
											name="amount"
											placeholder={t("property.enterAmount")}
											borderRadius="md"
											value={markAsPaidInformation.amount}
											onChange={handleChangeMarkAsPaidInformation}
										/>
										<InputRightElement pointerEvents="none">
											<Text fontSize="xs" color="gray.500">
												{currency}
											</Text>
										</InputRightElement>
									</InputGroup>
								</FormControl>
							) : (
								<>
									<Box>
										<Text fontSize="xs" color="gray.500" mb={1}>
											{t("property.amount")}
										</Text>
										<Text fontSize="md" fontWeight="bold">
											{amount} {currency}
										</Text>
									</Box>
									<Box>
										<Text fontSize="xs" color="gray.500" mb={1}>
											{t("property.type")}
										</Text>
										<Badge colorScheme="blue" fontSize="xs">
											{type}
										</Badge>
									</Box>
								</>
							)}
						</SimpleGrid>
					</PropertyModalSection>

					<PropertyModalSection icon={FiCalendar} title={t("property.paymentDetails")}>
						<VStack spacing={3} align="stretch">
							<SimpleGrid columns={2} spacing={4} w="full">
								<FormControl>
									<ModalFieldLabel icon={FiCalendar}>{t("property.paymentDate")}</ModalFieldLabel>
									<Input
										size="sm"
										type="date"
										name="paymentDate"
										borderRadius="md"
										value={markAsPaidInformation.paymentDate}
										onChange={handleChangeMarkAsPaidInformation}
									/>
								</FormControl>
								<FormControl>
									<ModalFieldLabel icon={FiFileText}>{t("property.documentNumber")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.documentNumber}
										type="text"
										name="documentNumber"
										placeholder={t("property.documentNumberPlaceholder")}
										borderRadius="md"
										value={markAsPaidInformation.documentNumber}
										onChange={handleChangeMarkAsPaidInformation}
									/>
								</FormControl>
							</SimpleGrid>
							<FormControl>
								<ModalFieldLabel icon={FiCreditCard}>{t("property.method")}</ModalFieldLabel>
								<Select size="sm" onChange={handleChangeMarkAsPaidInformation} name="paymentMethod" borderRadius="md" value={markAsPaidInformation.paymentMethod}>
									<option value="op">OP</option>
									<option value="cash">Cash</option>
									{type.toLowerCase().includes("utility") && <option value="personal">Personal</option>}
								</Select>
							</FormControl>
						</VStack>
					</PropertyModalSection>

					{type === "rent" && (
						<PropertyModalSection icon={FiGlobe} title={t("property.currencyExchange")}>
							<VStack spacing={3} align="stretch">
								<Checkbox
									isDisabled={exchangeRateLoading}
													isChecked={markAsPaidInformation.exchange}
													onChange={(e) => {
														if (!e.target.checked) {
															setMarkAsPaidInformation({ ...markAsPaidInformation, exchange: null });
															onDifferentCurrencyClose();
															return;
														}
														if (property.rent.exchangeRateType === "fixedExchangeRate") {
															console.log("fixed exchange rate");
															const destinationCurrency = currency === "ron" ? "eur" : "ron";
															setMarkAsPaidInformation({
																...markAsPaidInformation,
																exchange: {
																	amount: Number(
																		destinationCurrency === "ron" ? amount * property.rent.fixedExchangeRate : amount / property.rent.fixedExchangeRate
																	).toFixed(2),
																	currency: destinationCurrency,
																	exchangeRate: property.rent.fixedExchangeRate,
																	exchangeRateType: "fixedExchangeRate",
																},
															});
															onDifferentCurrencyToggle();
														} else {
															console.log("bnr exchange rate");
															setExchangeRateLoading(true);
															API.get(`get-exchange-rate?date=${markAsPaidInformation.paymentDate}`)
																.then((r) => {
																	console.log(r);
																	const rate = property.rent.exchangeRateType === "bnr" ? r.data.rate : r.data.rate * 1.02;
																	const destinationCurrency = currency === "ron" ? "eur" : "ron";
																	setMarkAsPaidInformation({
																		...markAsPaidInformation,
																		exchange: {
																			amount: Number(destinationCurrency === "ron" ? amount * rate : amount / rate).toFixed(2),
																			currency: destinationCurrency,
																			exchangeRate: Number(rate).toFixed(4),
																			exchangeRateType: property.rent.exchangeRateType,
																		},
																	});
																	onDifferentCurrencyToggle();
																})
																.catch((err) => {
																	console.log(err);
																	toast({
																		title: "Error encountered",
																		description: "Could not get exchange rate. Try again later.",
																		status: "error",
																		duration: 9000,
																		isClosable: true,
																	});
																	setMarkAsPaidInformation({ ...markAsPaidInformation, exchange: null });
																	onDifferentCurrencyClose();
																})
																.finally(() => {
																	setExchangeRateLoading(false);
																});
														}
													}}
								>
									<HStack spacing={2}>
										<Text fontSize="sm">{t("property.billedInDifferentCurrency")}</Text>
										{exchangeRateLoading && <Spinner size="sm" />}
									</HStack>
								</Checkbox>

								<Collapse in={isDifferentCurrencyOpen} animateOpacity>
									<Alert status="info" borderRadius="md" size="sm">
										<AlertIcon />
										<VStack align="start" spacing={1}>
											<AlertTitle fontSize="sm">{t("property.exchangeRateInfo")}</AlertTitle>
															<AlertDescription fontSize="sm">
																{`1 EUR = ${markAsPaidInformation.exchange?.exchangeRate} RON`}{" "}
																{markAsPaidInformation.exchange?.exchangeRateType === "fixedExchangeRate"
																	? "(Fixed Rate)"
																	: markAsPaidInformation.exchange?.exchangeRateType === "bnr"
																	? "(BNR Rate)"
																	: "(BNR Rate + 2%)"}
															</AlertDescription>
														</VStack>
													</Alert>

									<SimpleGrid columns={2} spacing={4} mt={3}>
										<Box>
											<Text fontSize="xs" color="gray.500" mb={1}>
												{t("property.equivalentAmount")}
											</Text>
											<Text fontSize="md" fontWeight="bold" color="green.500">
												{markAsPaidInformation.exchange?.amount}
											</Text>
										</Box>
										<Box>
											<Text fontSize="xs" color="gray.500" mb={1}>
												{t("property.currency")}
											</Text>
											<Badge colorScheme="green" fontSize="xs">
												{markAsPaidInformation.exchange?.currency?.toUpperCase()}
											</Badge>
										</Box>
									</SimpleGrid>
								</Collapse>
							</VStack>
						</PropertyModalSection>
					)}
				</VStack>

				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection icon={FiUser} title={t("property.billingInformation")}>
						<VStack spacing={3} align="stretch">
							<FormControl>
								<ModalFieldLabel icon={FiUser}>{t("property.billedTo")}</ModalFieldLabel>
								<Select size="sm" onChange={handleBilledToChange} name="billedTo" placeholder={t("property.selectRecipient")} borderRadius="md">
									<option value={property.owner.email}>{property.owner.name}</option>
									{property.tenants?.map((c, index) => (
										<option key={index} value={c.email}>
											{c.name}
										</option>
									))}
									{property.contacts?.map((c, index) => (
										<option key={index} value={c.email}>
											{c.name}
										</option>
									))}
									{property.leaseContacts?.map((c, index) => (
										<option key={index} value={c.id}>
											{c.name}
										</option>
									))}
								</Select>
							</FormControl>
							<SimpleGrid columns={2} spacing={4} w="full">
								<FormControl>
									<ModalFieldLabel icon={FiUser}>{t("property.billedToName")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.billedToName}
										type="text"
										name="name"
										placeholder={t("property.namePlaceholder")}
										borderRadius="md"
										value={markAsPaidInformation.billedTo.name}
										onChange={(e) => {
											setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { ...markAsPaidInformation.billedTo, name: e.target.value } });
										}}
									/>
								</FormControl>
								<FormControl>
									<ModalFieldLabel icon={FiFileText}>{t("property.billedToType")}</ModalFieldLabel>
									<Input
										size="sm"
										isInvalid={error?.billedToType}
										type="text"
										name="type"
										placeholder={t("property.selectContactType")}
										borderRadius="md"
										value={markAsPaidInformation.billedTo.type}
										onChange={(e) => {
											setMarkAsPaidInformation({ ...markAsPaidInformation, billedTo: { ...markAsPaidInformation.billedTo, type: e.target.value } });
										}}
									/>
								</FormControl>
							</SimpleGrid>
							<FormControl>
								<ModalFieldLabel icon={FiFileText}>{t("property.description")}</ModalFieldLabel>
								<Textarea
									size="sm"
									isInvalid={error?.description}
									name="description"
									placeholder={t("property.descriptionPlaceholder")}
									borderRadius="md"
									value={markAsPaidInformation.description}
									onChange={handleChangeMarkAsPaidInformation}
									rows={2}
								/>
							</FormControl>
						</VStack>
					</PropertyModalSection>

					<PropertyModalSection icon={FiUpload} title={t("property.supportingDocuments")}>
						<Dropzone
							onDrop={onDocumentDrop}
							accept={{
								"application/pdf": [".pdf"],
								"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
								"application/msword": [".doc"],
							}}
							description={t("property.uploadPdfDocDocx")}
						/>
					</PropertyModalSection>
				</VStack>
			</SimpleGrid>
		</PropertyModalShell>
	);
	const renderDeleteConfirmationModal = () => (
		<PropertyConfirmModal
			isOpen={isDeleteConfirmationOpen}
			onClose={onDeleteConfirmationClose}
			onConfirm={handleDeletePayment}
			message={t("property.deletePaymentConfirmation")}
			emphasis={t("property.actionCannotBeUndone")}
		/>
	);
	const renderViewDocumentsModal = () => (
		<PropertyModalShell
			isOpen={isOpen}
			onClose={onClose}
			size="4xl"
			icon={FiFileText}
			title={t("property.paymentDetailsTitle")}
			subtitle={t("property.viewPaymentSubtitle")}
			headerExtra={
				<Badge colorScheme={getPaymentStatusColor(paymentStatus)} fontSize="xs">
					{paymentStatus}
				</Badge>
			}
			footer={
				<ModalFooterActions
					onCancel={onClose}
					onConfirm={handleAddDocument}
					cancelLabel={t("misc.close")}
					confirmLabel={t("property.addNewDocument")}
					confirmIcon={FiUpload}
					isDisabled={!addDocumentInformation.documentName}
				/>
			}
		>
			<SimpleGrid columns={{ base: 1, lg: 2 }} spacing={MODAL_GRID_SPACING}>
				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection icon={FiInfo} title={t("property.paymentSummary")}>
						<SimpleGrid columns={2} spacing={4}>
							<Box>
								<Text fontSize="xs" color="gray.500" mb={1}>
									{t("property.amount")}
								</Text>
								<Text fontSize="md" fontWeight="bold">
									{paymentDirection === "outgoing" || type === "administrationFee" ? "-" : "+"}
									{Number(amount).toFixed(2)} {currency}
								</Text>
								{exchange && (
									<Text fontSize="xs" color="gray.500" mt={1}>
										({Number(exchange.amount).toFixed(2)} {exchange.currency})
									</Text>
								)}
							</Box>
							<Box>
								<Text fontSize="xs" color="gray.500" mb={1}>
									{t("property.type")}
								</Text>
								<Badge colorScheme="blue" fontSize="xs">
									{t(`types.${type}`)}
								</Badge>
							</Box>
						</SimpleGrid>
						{description && (
							<Box mt={3}>
								<Text fontSize="xs" color="gray.500" mb={1}>
									{t("property.description")}
								</Text>
								<Text fontSize="sm" bg="gray.50" p={2} borderRadius="md">
									{description}
								</Text>
							</Box>
						)}
					</PropertyModalSection>

					<PropertyModalSection icon={FiCalendar} title={t("property.paymentTimeline")}>
						<SimpleGrid columns={2} spacing={4}>
							<Box>
								<Text fontSize="xs" color="gray.500" mb={1}>
									{t("property.issueDate")}
								</Text>
								<Text fontSize="sm">{moment(date).format(fullDateTimeFormat)}</Text>
							</Box>
							{dueDate && (
								<Box>
									<Text fontSize="xs" color="gray.500" mb={1}>
										{t("table.dueDate")}
									</Text>
									<Text fontSize="sm">{moment(dueDate).format(fullDateFormat)}</Text>
								</Box>
							)}
						</SimpleGrid>
						<Box mt={3}>
							<Text fontSize="xs" color="gray.500" mb={1}>
								{t("property.paymentDate")}
							</Text>
							<Text fontSize="sm" color={paymentDate ? "green.500" : "gray.500"}>
								{paymentDate ? moment(paymentDate).format(fullDateTimeFormat) : t("property.notPaidYet")}
							</Text>
						</Box>
						{code && (
							<Box mt={3}>
								<Text fontSize="xs" color="gray.500" mb={1}>
									{t("property.documentNumber")}
								</Text>
								<Text fontSize="sm" fontFamily="mono" bg="gray.50" p={2} borderRadius="md">
									{code}
								</Text>
							</Box>
						)}
					</PropertyModalSection>
				</VStack>

				<VStack spacing={MODAL_SECTION_SPACING} align="stretch">
					<PropertyModalSection
						icon={FiUpload}
						title={t("property.existingDocuments")}
						headerExtra={
							<Badge colorScheme="blue" fontSize="xs">
								{documents?.length || 0}
							</Badge>
						}
					>
						{documents && documents.length > 0 ? (
							<VStack spacing={2} align="stretch">
								{documents.map((d, index) => (
									<Box
										key={index}
										p={2}
										border="1px"
										borderColor="gray.200"
										borderRadius="md"
										_hover={{ bg: "gray.50" }}
										cursor="pointer"
										onClick={() => handleGetDocument(d.id, d.documentName)}
									>
										<HStack justify="space-between">
											<HStack spacing={2}>
												<Icon as={FiFileText} color={iconColor} boxSize={4} />
												<VStack align="start" spacing={0}>
													<Text fontSize="sm" fontWeight="medium" noOfLines={1}>
														{d.documentName}
													</Text>
													<Text fontSize="xs" color="gray.500">
														{t("property.clickToDownload")}
													</Text>
												</VStack>
											</HStack>
											<Icon as={DownloadIcon} color={iconColor} boxSize={4} />
										</HStack>
									</Box>
								))}
							</VStack>
						) : (
							<Box textAlign="center" py={4}>
								<Icon as={FiFileText} color="gray.300" boxSize={6} mb={2} />
								<Text fontSize="sm" color="gray.500">
									{t("property.noDocumentsAttached")}
								</Text>
							</Box>
						)}
					</PropertyModalSection>

					<PropertyModalSection icon={FiUpload} title={t("property.addNewDocument")}>
						<VStack spacing={3} align="stretch">
							<Dropzone
								onDrop={onAddDocumentDrop}
								accept={{
									"application/pdf": [".pdf"],
									"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
									"application/msword": [".doc"],
								}}
								description={t("property.uploadPdfDocDocx")}
							/>
							{addDocumentInformation.documentName && (
								<Alert status="info" borderRadius="md" size="sm">
									<AlertIcon />
									<VStack align="start" spacing={0}>
										<AlertTitle fontSize="sm">{t("property.documentReady")}</AlertTitle>
										<AlertDescription fontSize="xs">
											{t("property.documentReadyDescription", { name: addDocumentInformation.documentName })}
										</AlertDescription>
									</VStack>
								</Alert>
							)}
						</VStack>
					</PropertyModalSection>
				</VStack>
			</SimpleGrid>
		</PropertyModalShell>
	);
	return (
		<Tr>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Flex direction="column">
					<Tooltip label={moment(date).format(fullDateTimeFormat)} placement="top">
						<Text noOfLines={1} fontSize="sm">
							{moment(date).format(fullDateTimeFormat)}
						</Text>
					</Tooltip>
					{code && (
						<Text fontSize="xs" color="gray.500" noOfLines={1}>
							{t("table.number")}: {code}
						</Text>
					)}
				</Flex>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Badge colorScheme={getPaymentStatusColor(paymentStatus)} fontSize="sm">
					{paymentStatus}
				</Badge>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Tooltip label={dueDate ? moment(dueDate).format(fullDateFormat) : "-"} placement="top">
					<Text noOfLines={1} fontSize="sm">
						{dueDate ? moment(dueDate).format(fullDateFormat) : "-"}
					</Text>
				</Tooltip>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Text noOfLines={1} fontSize="sm">
					{paymentDirection === "outgoing" || type === "administrationFee" ? "-" : "+"}
					{Number(amount).toFixed(2)} {currency}
					{exchange && (
						<Text as="span" fontSize="xs" color="gray.500" ml={1}>
							({Number(exchange.amount).toFixed(2)} {exchange.currency})
						</Text>
					)}
				</Text>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Text noOfLines={1} fontSize="sm">
					{method}
				</Text>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Text noOfLines={1} fontSize="sm">
					{t(`types.${type}`)}
				</Text>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Tooltip label={paymentDate ? moment(paymentDate).format(fullDateFormat) : "-"} placement="top">
					<Text noOfLines={1} fontSize="sm">
						{paymentDate ? moment(paymentDate).format(fullDateFormat) : "-"}
					</Text>
				</Tooltip>
			</Td>
			<Td borderBottom="1px" borderColor={borderColor}>
				<Menu closeOnSelect={false}>
					<MenuButton as={IconButton} size="sm" icon={<HamburgerIcon />} variant="ghost" colorScheme="blue" />
					<MenuList>
						<MenuItem
							isDisabled={paymentStatus === "Paid"}
							onClick={() => {
								onMarkAsPaidOpen();
								if (type === "rent") {
									const lastRentPayment = [...property.payments]
										.sort((a, b) => moment(b.issuedDate).unix() - moment(a.issuedDate).unix())
										.find((p) => p.type === "rent" && p.paymentDate);
									setMarkAsPaidInformation({ ...markAsPaidInformation, amount: amount, description: lastRentPayment.description || "" });
								} else {
									setMarkAsPaidInformation({ ...markAsPaidInformation, amount: amount });
								}
							}}
						>
							{t("table.markAsPaid")}
						</MenuItem>
						<MenuItem onClick={onOpen}>{t("table.viewDetails")}</MenuItem>
						<MenuItem onClick={generateDisposition} hidden={true} isDisabled={loading}>
							{t("table.generateDisposition")} {loading && <Spinner size="sm" ml={2} />}
						</MenuItem>
						<MenuItem onClick={onDeleteConfirmationOpen}>{t("table.delete")}</MenuItem>
					</MenuList>
				</Menu>

				{renderViewDocumentsModal()}
				{renderMarkAsPaidModal()}
				{renderDeleteConfirmationModal()}
			</Td>
		</Tr>
	);
}

export default InvoicesRow;
